import React from "react";
import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogTitle,
    IconButton,
    TextField,
    InputAdornment,
    Box,
    Typography,
    Chip,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

const SelectedManagersDialog = ({ open, onClose, managers = [], setValue }) => {
    const { t } = useTranslation("dashboard");
    const [search, setSearch] = React.useState("");

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleRemove = (managerToRemove) => {
        setValue(
            "manager",
            managers.filter((m) => m.name !== managerToRemove)
        );
    };

    const filteredManagers = managers.filter((manager) =>
        manager.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="xs"
            transitionDuration={400}
            PaperProps={{
                sx: {
                    borderRadius: fullScreen ? 0 : 3,
                    p: 2,
                    width: "100%",
                    mx: "auto",
                    mt: fullScreen ? "auto" : 8,
                    maxHeight: "80vh",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: "center",
                    fontWeight: 700,
                    color: "#6A0DAD",
                    fontSize: 18,
                    textTransform: "lowercase",
                    position: "relative",
                    pb: 1
                }}
            >
                {t("teamMemberLinkingFormTeamMemberManager")}
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Box px={2} pb={2}>
                <TextField
                    fullWidth
                    placeholder={t("teamMemberLinkingDialogSearch")}
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{
                        mb: 2,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: 2.5,
                            backgroundColor: "#F5F5F5",
                            fontSize: 14,
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon sx={{ color: "#999" }} />
                            </InputAdornment>
                        ),
                    }}
                />

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        maxHeight: "60vh",
                        overflowY: "auto"
                    }}
                >
                    {filteredManagers.length > 0 ? (
                        filteredManagers.map((manager, idx) => (
                            <Chip
                                key={idx}
                                label={manager.name.toLowerCase()}
                                onDelete={() => handleRemove(manager.name)}
                                sx={{
                                    bgcolor: "#EEDCFF",
                                    color: "#6A0DAD",
                                    fontWeight: 500,
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 2,
                                    fontSize: 14,
                                    textTransform: "lowercase",
                                    width: "fit-content",
                                    "& .MuiChip-deleteIcon": {
                                        color: "#8800F7",
                                    },
                                }}
                            />
                        ))
                    ) : (
                        <Typography sx={{ color: "#888", textAlign: "center", mt: 4 }}>
                            {t("teamMemberLinkingDialogNoMatchingManager")}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Dialog>
    );
};

export default SelectedManagersDialog;
